import(/* webpackMode: "eager" */ "/codebuild/output/src52593423/src/github.com/bitstone/offerz-nextjs/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src52593423/src/github.com/bitstone/offerz-nextjs/node_modules/@mui/material/CircularProgress/index.js");
